import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
  fill: "#00408C"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M25.1063 11C32.018 11.3238 37.6362 16.91 37.9596 23.8321C34.6048 23.8321 29.7141 23.5892 27.3698 22.051C25.4701 20.7961 25.1063 13.6312 25.1063 11ZM11 23.8321C11.3234 16.91 16.9416 11.3238 23.8533 11C23.8533 13.6312 23.5299 20.7961 21.5494 22.051C19.2455 23.5892 14.3548 23.8321 11 23.8321ZM23.8937 38C16.982 37.7166 11.3638 32.1304 11.0404 25.2084C14.3952 25.2084 19.2859 25.4108 21.6302 26.949C23.5299 28.2849 23.8937 35.4093 23.8937 38ZM38 25.2084C37.6766 32.1304 32.0584 37.7166 25.1467 38C25.1467 35.4093 25.4701 28.2444 27.4506 26.949C29.7545 25.4108 34.6452 25.2084 38 25.2084Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue';
  
  interface IProps {
    color?: string;
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'DatalogicIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

  const props = __props;
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})